import __request__ from "routing/request";
export function prepareGenericShare(JSONBody, requestOptions) {
  return __request__("POST", "/authz/shares/entities/prepare", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateEntityShares(entityGRN, JSONbody, requestOptions) {
  return __request__("POST", `/authz/shares/entities/${entityGRN}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function prepareShare(entityGRN, JSONbody, requestOptions) {
  return __request__("POST", `/authz/shares/entities/${entityGRN}/prepare`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(userId, paginationparameters, capability, entity_type, requestOptions) {
  return __request__("GET", `/authz/shares/user/${userId}`, paginationparameters, { "capability": capability, "entity_type": entity_type }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
